import { FunctionComponent } from 'react';
import CourseLanding from '../../components/courseLanding';
import SectionTitle from '../../../course/components/sectionTitle';
import Quiz from '../../components/quiz';
import Animation014 from './animation014';
import Animation019 from './animation019';
import Animation022 from './animation022';
import Component003 from './component003';
import Component004 from './component004';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Animation014,
  Animation019,
  Animation022,
  Component003,
  Component004,
};

export default Components;
